import { Box, Flex, Text } from '@chakra-ui/react'

import {
  Box as DarkBox,
  Button as DarkButton,
  Flex as DarkFlex,
  Text as DarkText,
  tokenPrefix,
  tokenVar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { Button } from '@/components/ui'
import { formatDateTime } from '@/utils/formatDateTime'

import { IncidentOptionI } from '../../types/types'

interface PresetIncidentCardIProps {
  colorScheme?: ColorScheme
  presetIncident: IncidentOptionI
  onSelectNewIncident: () => void
}

export const PresetIncidentCard = ({
  colorScheme,
  presetIncident,
  onSelectNewIncident,
}: PresetIncidentCardIProps) => {
  const tokenPathPrefix = colorScheme ? tokenPrefix(colorScheme) : ''
  const secondaryTextColor = colorScheme
    ? tokenVar(`colors.${tokenPathPrefix}text.secondary`)
    : 'gray.600'
  const borderColor = colorScheme
    ? tokenVar(`colors.${tokenPathPrefix}border.default`)
    : 'gray.200'

  if (colorScheme) {
    return (
      <DarkFlex
        border='1px solid'
        borderColor={borderColor}
        borderRadius='12px'
        direction='column'
        gap='16px'
        p='24px'
      >
        <DarkBox>
          <DarkText color={secondaryTextColor} fontSize='12px' fontWeight='600'>
            Selected Incident
          </DarkText>
          <DarkText fontSize='24px' fontWeight='bold' mt='4px'>
            {presetIncident.incidentId}
          </DarkText>
          {presetIncident.createdAt && (
            <DarkText color={secondaryTextColor} fontSize='14px' mt='4px'>
              {formatDateTime(presetIncident.createdAt)}
            </DarkText>
          )}
        </DarkBox>
        <DarkButton
          colorScheme={colorScheme}
          onClick={onSelectNewIncident}
          size='sm'
          variant='secondary'
        >
          Select New Incident
        </DarkButton>
      </DarkFlex>
    )
  }

  return (
    <Flex
      border='1px solid'
      borderColor={borderColor}
      borderRadius='xl'
      direction='column'
      gap={4}
      p={6}
    >
      <Box>
        <Text color={secondaryTextColor} fontSize='xs' fontWeight={600}>
          Selected Incident
        </Text>
        <Text fontSize='2xl' fontWeight='bold' mt={1}>
          {presetIncident.incidentId}
        </Text>
        {presetIncident.createdAt && (
          <Text color={secondaryTextColor} fontSize='sm' mt={1}>
            {formatDateTime(presetIncident.createdAt)}
          </Text>
        )}
      </Box>
      <Button
        _hover={{ bg: 'purple.100' }}
        bg='purple.50'
        border='1px solid'
        borderColor='purple.200'
        color='purple.700'
        onClick={onSelectNewIncident}
        size='sm'
        variant='ghost'
      >
        Select New Incident
      </Button>
    </Flex>
  )
}
